export default "__VITE_ASSET__16597d34__"